var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4H2L2 12H10V4ZM2 2C0.895431 2 0 2.89543 0 4V12C0 13.1046 0.895431 14 2 14H10C11.1046 14 12 13.1046 12 12V10.7273L14.4538 12.3276C15.1189 12.7614 16 12.2841 16 11.49V5.18207C16 4.38795 15.1189 3.91066 14.4538 4.34446L12 5.94475V4C12 2.89543 11.1046 2 10 2H2ZM12 8.33956V8.33249L14 7.02812V9.64394L12 8.33956ZM2.66663 10C2.66663 9.44772 3.11434 9 3.66663 9H6.99996C7.55224 9 7.99996 9.44772 7.99996 10C7.99996 10.5523 7.55224 11 6.99996 11H3.66663C3.11434 11 2.66663 10.5523 2.66663 10Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVCamera);
export default __webpack_public_path__ + "static/media/v-camera.2c77227f.svg";
export { ForwardRef as ReactComponent };